<!--Gallery Hover Effect Starts-->
<div class="row">
  <div class="col-12">
    <div class="content-header">Gallery with Hover Effects</div>
    <p class="content-sub-header mb-1">Image gallery grid with some subtle hover effect. Try to hover these demo images to see different hover effects.</p>
  </div>
</div>
<section id="gallery-hover-effects">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body" itemscope itemtype="http://schema.org/ImageGallery">

            <div class="grid-hover">
              <div class="row">
                <div class="col-md-6 col-12">
                  <h5 class="text-bold-400 text-uppercase">Lily</h5>
                  <figure class="effect-lily">
                    <img src="assets/img/gallery/19.jpg" alt="img">
                    <figcaption>
                      <div>
                        <h2>Nice
                          <span>Lily</span>
                        </h2>
                        <p>Lily likes to play with crayons and pencils</p>
                      </div>
                    </figcaption>
                  </figure>
                </div>
                <div class="col-md-6 col-12">
                  <h5 class="text-bold-400 text-uppercase">Sadie</h5>
                  <figure class="effect-sadie">
                    <img src="assets/img/gallery/2.jpg" alt="img">
                    <figcaption>
                      <h2>Holy
                        <span>Sadie</span>
                      </h2>
                      <p>Sadie never took her eyes off me.
                        <br>She had a dark soul.</p>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>

            <div class="grid-hover">
              <div class="row">
                <div class="col-md-6 col-12">
                  <h5 class="text-bold-400 text-uppercase">Honey</h5>
                  <figure class="effect-honey">
                    <img src="assets/img/gallery/3.jpg" alt="img">
                    <figcaption>
                      <h2>Dreamy
                        <span>Honey</span> <i>Now</i></h2>
                    </figcaption>
                  </figure>
                </div>
                <div class="col-md-6 col-12">
                  <h5 class="text-bold-400 text-uppercase">Layla</h5>
                  <figure class="effect-layla">
                    <img src="assets/img/gallery/17.jpg" alt="img">
                    <figcaption>
                      <h2>Crazy
                        <span>Layla</span>
                      </h2>
                      <p>When Layla appears, she brings an eternal summer along.</p>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>

            <div class="grid-hover">
              <div class="row">
                <div class="col-md-6 col-12">
                  <h5 class="text-bold-400 text-uppercase">Zoe</h5>
                  <figure class="effect-zoe">
                    <img src="assets/img/gallery/22.jpg" alt="img">
                    <figcaption>
                      <h2>Creative
                        <span>Zoe</span>
                      </h2>
                      <p class="icon-links">
                        <a href="javascript:;" class="mr-1"><i class="ft-heart"></i></a>
                        <a href="javascript:;" class="mr-1"><i class="ft-eye"></i></a>
                        <a href="javascript:;" class="mr-1"><i class="ft-edit"></i></a>
                      </p>
                      <p class="description">Zoe never had the patience of her sisters. She deliberately punched the bear in his face.</p>
                    </figcaption>
                  </figure>
                </div>
                <div class="col-md-6 col-12">
                  <h5 class="text-bold-400 text-uppercase">Oscar</h5>
                  <figure class="effect-oscar">
                    <img src="assets/img/gallery/7.jpg" alt="img">
                    <figcaption>
                      <h2>Warm
                        <span>Oscar</span>
                      </h2>
                      <p>Oscar is a decent man. He used to clean porches with pleasure.</p>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>

            <div class="grid-hover">
              <div class="row">
                <div class="col-md-6 col-12">
                  <h5 class="text-bold-400 text-uppercase">Marley</h5>
                  <figure class="effect-marley">
                    <img src="assets/img/gallery/26.jpg" alt="img">
                    <figcaption>
                      <h2>Sweet
                        <span>Marley</span>
                      </h2>
                      <p>Marley tried to convince her but she was not interested.</p>
                    </figcaption>
                  </figure>
                </div>
                <div class="col-md-6 col-12">
                  <h5 class="text-bold-400 text-uppercase">Ruby</h5>
                  <figure class="effect-ruby">
                    <img src="assets/img/gallery/9.jpg" alt="img">
                    <figcaption>
                      <h2>Glowing
                        <span>Ruby</span>
                      </h2>
                      <p>Ruby did not need any help. Everybody knew that.</p>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>

            <div class="grid-hover">
              <div class="row">
                <div class="col-md-6 col-12">
                  <h5 class="text-bold-400 text-uppercase">Roxy</h5>
                  <figure class="effect-roxy">
                    <img src="assets/img/gallery/10.jpg" alt="img">
                    <figcaption>
                      <h2>Charming
                        <span>Roxy</span>
                      </h2>
                      <p>Roxy was my best friend. She'd cross any border for me.</p>
                    </figcaption>
                  </figure>
                </div>
                <div class="col-md-6 col-12">
                  <h5 class="text-bold-400 text-uppercase">Bubba</h5>
                  <figure class="effect-bubba">
                    <img src="assets/img/gallery/11.jpg" alt="img">
                    <figcaption>
                      <h2>Fresh
                        <span>Bubba</span>
                      </h2>
                      <p>Bubba likes to appear out of thin air.</p>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>

            <div class="grid-hover">
              <div class="row">
                <div class="col-md-6 col-12">
                  <h5 class="text-bold-400 text-uppercase">Romeo</h5>
                  <figure class="effect-romeo">
                    <img src="assets/img/gallery/24.jpg" alt="img">
                    <figcaption>
                      <h2>Wild
                        <span>Romeo</span>
                      </h2>
                      <p>Romeo never knows what he wants. He seemed to be very cross about something.</p>
                    </figcaption>
                  </figure>
                </div>
                <div class="col-md-6 col-12">
                  <h5 class="text-bold-400 text-uppercase">Dexter</h5>
                  <figure class="effect-dexter">
                    <img src="assets/img/gallery/13.jpg" alt="img">
                    <figcaption>
                      <h2>Strange
                        <span>Dexter</span>
                      </h2>
                      <p>Dexter had his own strange way. You could watch him training ants.
                      </p>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>

            <div class="grid-hover">
              <div class="row">
                <div class="col-md-6 col-12">
                  <h5 class="text-bold-400 text-uppercase">Sarah</h5>
                  <figure class="effect-sarah">
                    <img src="assets/img/gallery/14.jpg" alt="img">
                    <figcaption>
                      <h2>Free
                        <span>Sarah</span>
                      </h2>
                      <p>Sarah likes to watch clouds. She's quite depressed.</p>
                    </figcaption>
                  </figure>
                </div>
                <div class="col-md-6 col-12">
                  <h5 class="text-bold-400 text-uppercase">Chico</h5>
                  <figure class="effect-chico">
                    <img src="assets/img/gallery/15.jpg" alt="img">
                    <figcaption>
                      <h2>Silly
                        <span>Chico</span>
                      </h2>
                      <p>Chico's main fear was missing the morning bus.</p>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>

            <div class="grid-hover">
              <div class="row">
                <div class="col-md-6 col-12">
                  <h5 class="text-bold-400 text-uppercase">Milo</h5>
                  <figure class="effect-milo">
                    <img src="assets/img/gallery/31.jpg" alt="img">
                    <figcaption>
                      <h2>Faithful
                        <span>Milo</span>
                      </h2>
                      <p>Milo went to the woods. He took a fun ride and never came back.
                      </p>
                    </figcaption>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Gallery Hover Effect Starts-->
